import { SimpleFillSymbol, SimpleLineSymbol, SimplePointSymbol } from "../symbol/symbol";
import { GeometryType } from "../geometry/geometry";
import { Color } from "../util/color";
import { Renderer } from "./renderer";
/**
 * 分级渲染项
 * @remarks
 * 分级区间一般为( ]: 即下开上闭
 */
export class ClassRendererItem {
    /**
     * 构造函数
     * @param {number} low - 下限
     * @param {number} high - 上限
     * @param {Symbol} symbol - 渲染符号
     * @param {string} label - 分级标题
     */
    constructor(low, high, symbol, label) {
        this.low = low;
        this.high = high;
        this.symbol = symbol;
        this.label = label;
    }
}
/**
 * 分级渲染
 * @remarks
 * 一般可通过设置分级字段，再调用generate自动生成分级渲染项
 * 也可通过手动添加和定义分级渲染项，完成分级渲染设置，通过items.push()
 */
export class ClassRenderer extends Renderer {
    constructor() {
        super(...arguments);
        /**
         * 所有分级渲染项集合
         */
        this._items = [];
    }
    /**
     * 分级字段
     * @remarks
     * 必须为数值型
     */
    get field() {
        return this._field;
    }
    /**
     * 设置分级字段
     */
    set field(value) {
        this._field = value;
    }
    /**
     * 所有分级渲染项集合
     */
    get items() {
        return this._items;
    }
    /**
     * 自动生成分级渲染项
     * @remarks
     * TODO: 分级有多种方式，目前只实现均分
     * @param {FeatureClass} featureClass - 要素类（要素集合）
     * @param {Field} field - 分级字段
     * @param {number} breaks - 分级数量
     */
    generate(featureClass, field, breaks) {
        this._field = field;
        this._items = [];
        //获取该字段极值
        const stat = featureClass.features.map(feature => feature.properties[field.name]).reduce((stat, cur) => {
            stat.max = Math.max(cur, stat.max);
            stat.min = Math.min(cur, stat.min);
            return stat;
        }, { min: Number.MAX_VALUE, max: Number.MIN_VALUE });
        for (let i = 0; i < breaks; i++) {
            const item = new ClassRendererItem();
            switch (featureClass.type) {
                case GeometryType.Point:
                    // case GeometryType.MultiplePoint:
                    const symbol1 = new SimplePointSymbol();
                    symbol1.fillStyle = Color.random().toString();
                    symbol1.strokeStyle = Color.random().toString();
                    item.symbol = symbol1;
                    item.low = stat.min + i * (stat.max - stat.min) / breaks;
                    item.high = stat.min + (i + 1) * (stat.max - stat.min) / breaks;
                    item.label = item.low + " - " + item.high;
                    this._items.push(item);
                    break;
                case GeometryType.Polyline:
                    // case GeometryType.MultiplePolyline:
                    const symbol2 = new SimpleLineSymbol();
                    symbol2.strokeStyle = Color.random().toString();
                    item.symbol = symbol2;
                    item.low = stat.min + i * (stat.max - stat.min) / breaks;
                    item.high = stat.min + (i + 1) * (stat.max - stat.min) / breaks;
                    item.label = item.low + " - " + item.high;
                    this._items.push(item);
                    break;
                case GeometryType.Polygon:
                    // case GeometryType.MultiplePolygon:
                    const symbol3 = new SimpleFillSymbol();
                    symbol3.fillStyle = Color.random().toString();
                    symbol3.strokeStyle = Color.random().toString();
                    item.symbol = symbol3;
                    item.low = stat.min + i * (stat.max - stat.min) / breaks;
                    item.high = stat.min + (i + 1) * (stat.max - stat.min) / breaks;
                    item.label = item.low + " - " + item.high;
                    this._items.push(item);
                    break;
            }
        }
    }
    /**
     * 根据矢量要素获取渲染符号
     * @param {Feature} feature - 矢量要素
     * @return {Symbol} 返回渲染符号
     */
    getSymbol(feature) {
        const item = this.items.find(item => item.low <= feature.properties[this.field.name] && item.high >= feature.properties[this.field.name]);
        if (item)
            return item.symbol;
    }
}
